import { Longhand } from "../longhand.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/visibility}
 * @internal
 */
export default Longhand.fromKeywords({ inherits: true }, "visible", "hidden", "collapse");
//# sourceMappingURL=visibility.js.map